import uploadApi from './UploadApi.js';

export default {
	uploadFile: async (formData) => {
		return await uploadApi().post('/v1/notificationAttachments/uploadFile',
			formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	}
}